import React from "react";

const Textarea = (props) => {
    // console.log('formik props', props.formikProps);
  return (
    <div className="inputContainer">
      {props.label && <label htmlFor={props.name}>{props.label}</label>}
      <textarea
        placeholder={props.placeholder}
        style={props.style}
        {...props.formikProps}
      />
      {props.formikTouch && props.formikErrors ? (
        <span className="errorText">{props.formikErrors}</span>
      ) : null}
    </div>
  );
};

export default Textarea;
